import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { ContentTVUnit } from '../../../services/content_v1';
import { useIsProvider } from '../../common';

interface ContentTVItemInfoProps {
    unit: ContentTVUnit
    dotted?: boolean
}

export function ContentTVItemInfo({ unit, dotted }: ContentTVItemInfoProps) {
    const isProvider = useIsProvider();
    return (
        dotted ? <>
            <div className="tv-list__item-theme">{unit.category?.name}</div>
            <div className="tv-card__info-list">
                <div className="tv-card__info-item">
                    {unit.tvqualities.map((tvq) => <span key={tvq.id}><span className="label-quality">{tvq.name} </span> </span>)}
                </div>
                <div className="tv-card__info-item">{unit.agerestriction?.name || '18+'}</div>
                <div className="tv-card__info-item _wide"><span className="tv-card__info-item-label"><Trans>Production</Trans>:</span> {unit?.countries.map(c => c.name).join(', ') || <span style={{ color: isProvider ? 'var(--c-red)' : 'var(--c-grey)' }}>{t('content:NOT_SPEC')}</span>}</div>
                <div className="tv-card__info-item _wide"><span className="tv-card__info-item-label"><Trans>Voice language</Trans>:</span> {unit?.languages?.map(c => c.name).join(', ') || <span style={{ color: isProvider ? 'var(--c-red)' : 'var(--c-grey)' }}>{t('content:NOT_SPEC')}</span>}</div>
                <div className="tv-card__info-item _wide"><span className="tv-card__info-item-label"><Trans>Subtitle</Trans>:</span> {unit?.subtitles?.map(c => c.name).join(', ') || <span style={{ color: isProvider ? 'var(--c-red)' : 'var(--c-grey)' }}>{t('content:NOT_SPEC')}</span>}</div>
                <div className="tv-card__info-item _wide"><span className="tv-card__info-item-label"><Trans>Broadcasting</Trans>:</span> {unit?.tvbrdcsterr?.map(c => c.name).join(', ') || <span style={{ color: isProvider ? 'var(--c-red)' : 'var(--c-grey)' }}>{t('content:NOT_SPEC')}</span>}</div>
                <div className="tv-card__info-item _wide"><span className="tv-card__info-item-label"><Trans>Distribution environment</Trans>:</span> {unit?.tvdienv?.map((tve) => tve.name).join(', ') || <span style={{ color: isProvider ? 'var(--c-red)' : 'var(--c-grey)' }}>{t('content:NOT_SPEC')}</span>}</div>
            </div>
        </>
            // <ul className="content-item__info-item">
            //     {!!unit.countries?.length &&
            //         unit.countries?.map(c => <li key={c.id}>{c.name}</li>)
            //     }
            //     {!!unit.tvqualities?.length &&
            //         unit.tvqualities?.map(q => <li key={q.id}><span className="label-quality">{q.name}</span></li>)
            //     }
            //     {!!unit.languages.length &&
            //         <li>
            //             <span className="label-audio">
            //                 <Subs />{unit.languages.map(l => l.name).join(', ')}
            //             </span>
            //         </li>
            //     }
            //     {!!unit.subtitles.length &&
            //         <li>
            //             <span className="label-audio">
            //                 <Audio />{unit.subtitles.map(l => l.name).join(', ')}
            //             </span>
            //         </li>
            //     }
            // </ul>
            :
            <div className="tv-card__info">
                <div className="tv-card__info-owner">{unit.owner?.name}</div>
                <div className="tv-card__info-list">
                    <div className="tv-card__info-item">
                        {unit.tvqualities.map((tvq) => <><span className="label-quality">{tvq.name}</span> </>)}
                    </div>
                    <div className="tv-card__info-item">{unit.agerestriction?.name || '18+'}</div>
                </div>
                <div className="tv-card__info-item"><span className="tv-card__info-item-label"><Trans>Production</Trans>:</span> {unit?.countries.map(c => c.name).join(', ') || <span style={{ color: isProvider ? 'var(--c-red)' : 'var(--c-grey)' }}>{t('content:NOT_SPEC')}</span>}</div>
                <div className="tv-card__info-item"><span className="tv-card__info-item-label"><Trans>Voice language</Trans>:</span> {unit?.languages?.map(c => c.name).join(', ') || <span style={{ color: isProvider ? 'var(--c-red)' : 'var(--c-grey)' }}>{t('content:NOT_SPEC')}</span>}</div>
                <div className="tv-card__info-item"><span className="tv-card__info-item-label"><Trans>Subtitle</Trans>:</span> {unit?.subtitles?.map(c => c.name).join(', ') || <span style={{ color: isProvider ? 'var(--c-red)' : 'var(--c-grey)' }}>{t('content:NOT_SPEC')}</span>}</div>
                <div className="tv-card__info-item"><span className="tv-card__info-item-label"><Trans>Broadcasting</Trans>:</span> {unit?.tvbrdcsterr?.map(c => c.name).join(', ') || <span style={{ color: isProvider ? 'var(--c-red)' : 'var(--c-grey)' }}>{t('content:NOT_SPEC')}</span>}</div>
                <div className="tv-card__info-item"><span className="tv-card__info-item-label"><Trans>Distribution environment</Trans>:</span> {unit?.tvdienv?.map((tve) => tve.name).join(', ') || <span style={{ color: isProvider ? 'var(--c-red)' : 'var(--c-grey)' }}>{t('content:NOT_SPEC')}</span>}</div>
            </div>
        // <div className="content-item__info">
        //     {!!unit.countries?.length &&
        //         <ul className="content-item__info-item">
        //             {unit.countries?.map(c => <li key={c.id}>{c.name}</li>)}
        //         </ul>
        //     }
        //     {!!unit.tvqualities?.length &&
        //         <div className="content-item__info-item">
        //             {unit.tvqualities?.map(q => <span key={q.id} className="label-quality">{q.name}</span>)}
        //         </div>
        //     }
        //     <ul className="content-item__info-item">
        //         {!!unit.languages.length &&
        //             <li>
        //                 <span className="label-audio">
        //                     <Subs />{unit.languages.map(l => l.name).join(', ')}
        //                 </span>
        //             </li>
        //         }
        //         {!!unit.subtitles.length &&
        //             <li>
        //                 <span className="label-audio">
        //                     <Audio />{unit.subtitles.map(l => l.name).join(', ')}
        //                 </span>
        //             </li>
        //         }
        //     </ul>
        // </div>
    );
}